import { render } from "./EventsList.vue?vue&type=template&id=3dce30ee"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"
script.render = render

export default script